import { render, staticRenderFns } from "./ApothekeDownloads.vue?vue&type=template&id=caee8eba&"
import script from "./ApothekeDownloads.vue?vue&type=script&lang=js&"
export * from "./ApothekeDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports